(function () {
    "use strict";

    var service = angular.module('downloadService', []);

    if (bm && bm.uris && bm.uris.downloadBaseUri) {
        service.constant('baseUrl', bm.uris.downloadBaseUri);
    } else {
        throw new Error('no base url for download service defined, aborting!');
    }
    service.constant('actions', {
        productCategoryAction: 'getProductCategories',
        productAction: 'getProducts',
        serialAction: 'getProductBySerial',
        documentAction: 'getDocuments',
        eulaAction: 'getEulas',
        translationsAction: 'getTranslations',
        allProductsAction: 'getAllProducts'
    });

    service.factory('DownloadService', [
        '$http', '$rootScope', 'baseUrl', 'actions',
        function ($http, $rootScope, baseUrl, actions) {

        var forEach = angular.forEach;

        function encodeUriSegment(val) {
            return encodeUriQuery(val, true).
                replace(/%26/gi, '&').
                replace(/%3D/gi, '=').
                replace(/%2B/gi, '+');
        }
        function encodeUriQuery(val, pctEncodeSpaces) {
            return encodeURIComponent(val).
                replace(/%40/gi, '@').
                replace(/%3A/gi, ':').
                replace(/%24/g, '$').
                replace(/%2C/gi, ',').
                replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
        }

        function Route(template, defaults) {
            this.template = decodeURIComponent(template);
            this.defaults = defaults || {};
            this.urlParams = {};
        }
        Route.prototype = {
            getUri: function (params) {
                var that = this,
                    url = that.template,
                    urlParams = that.urlParams = {},
                    val, encodedVal;

                params.solrLanguage = bm.defaults.solrLanguageCode;

                forEach(url.split(/\W/), function (param) {
                    if (param === 'hasOwnProperty') {
                        throw Error('badname', 'You don\'t want to use hasOwnProperty as a parameter name, really.');
                    }
                    if (! (/^\\d+$/.test(param)) && param && (new RegExp("(^|[^\\\\]):" + param + "(\\W|$)").test(url))) {
                        urlParams[param] = true;
                    }
                });
                url = url.replace(/\\:/g, ':');
                forEach(urlParams, function (_, urlParam) {
                    val = params.hasOwnProperty(urlParam) ? params[urlParam] : that.defaults[urlParam];
                    if (val !== undefined) {
                        encodedVal = encodeUriSegment(val);
                        url = url.replace(new RegExp(":" + urlParam + "(\\W|$)", "g"), function (match, p1) {
                            return encodedVal + p1;
                        });
                    } else {
                        url = url.replace(new RegExp("(\\?|\\&)[^\\&]+:" + urlParam, "g"), '');
                    }
                });
                return url;
            }
        };

        var router = new Route(baseUrl),
            getProductCategories = function (legacy, callback) {
                legacy = legacy || false;

                var uri = router.getUri({action: actions.productCategoryAction, legacy: +legacy});
                $http.get(uri)
                    .then(function (response) {
                        $rootScope.$broadcast('downloadService:getProductCategories:success', response.data, callback);
                    }, function (response) {
                        $rootScope.$broadcast('downloadService:getProductCategories:error', response);
                    });
            },
            getProducts = function (legacy, category, callback) {
                legacy = legacy || false;
                category = category || null;

                var uri = router.getUri({action: actions.productAction, legacy: +legacy, category: category ? category.AnacondaId_textS : null});
                $http.get(uri)
                    .then(function (response) {
                        $rootScope.$broadcast('downloadService:getProducts:success', response.data, callback);
                    }, function (response) {
                        $rootScope.$broadcast('downloadService:getProducts:error', response);
                    });
            },
            getProductBySerial = function (serial, callback) {
                var uri = router.getUri({action: actions.serialAction, serial: serial});
                $http.get(uri)
                    .then(function (response) {
                        $rootScope.$broadcast('downloadService:getProductBySerial:success', response.data, callback);
                    }, function (response) {
                        $rootScope.$broadcast('downloadService:getProductBySerial:error', response);
                    });
            },
            getDocuments = function (productId, callback) {
                var uri = router.getUri({action: actions.documentAction, productId: productId});
                $http.get(uri)
                    .then(function (response) {
                        $rootScope.$broadcast('downloadService:getDocuments:success', response.data, callback);
                    }, function (response) {
                        $rootScope.$broadcast('downloadService:getDocuments:error', response);
                    });
            },
            getEulas = function (callback) {
                var uri = router.getUri({action: actions.eulaAction});
                $http.get(uri)
                    .then(function (response) {
                        $rootScope.$broadcast('downloadService:getEulas:success', response.data, callback);
                    }, function (response) {
                        $rootScope.$broadcast('downloadService:getEulas:error', response);
                    });
            },
            getAllProducts = function (callback) {
                var uri = router.getUri({action: actions.allProductsAction});
                $http.get(uri)
                    .then(function (response) {
                        if (angular.isFunction(callback)) {
                            callback(response.data);
                        }
                    }, function (response) {
                        $rootScope.$broadcast('downloadService:getProducts:error', response);
                    });
            },
            bootstrap = function (callback) {
                // get translations
                var uri = router.getUri({action: actions.translationsAction});
                $http.get(uri)
                    .then(function (response) {
                        // now get categories and products
                        $rootScope.$broadcast('downloadService:getTranslations:success', response.data);
                        getEulas();
                        getProductCategories(false);
                        getProducts(false, null);
                        getAllProducts(callback);
                    }, function (response) {
                        $rootScope.$broadcast('downloadService:getTranslations:error', response);
                    });
            };

        return {
            getProductCategories: getProductCategories,
            getProducts: getProducts,
            getProductBySerial: getProductBySerial,
            getDocuments: getDocuments,
            getEulas: getEulas,
            getAllProducts: getAllProducts,
            init: bootstrap
        };
    }
    ]);
}());
